export default "__VITE_ASSET__Cxrz2xR4__"